    import { ref, computed } from 'vue'

    import { defineStore, acceptHMRUpdate } from 'pinia'

    export const useSmsStore = defineStore('sms', () => {

        const showSmsModal = ref(false)
        let smsIframeLoaded = false
        let smsRetryTimeout = null

         const handleSmsClose = () => {
            if (smsRetryTimeout) {
                clearTimeout(smsRetryTimeout)
                smsRetryTimeout = null
            }
            showSmsModal.value = false
            smsIframeLoaded = false
        }

        const addToSms = (celPhoneNumber) => {
            showSmsModal.value = true
            if (smsIframeLoaded === false) {
                smsRetryTimeout = setTimeout(() => {
                    smsRetryTimeout = null
                    addToSms(celPhoneNumber)
                }, 500)
            } else {
                const iframe = document.getElementById('coffee-sms')
                iframe.contentWindow.postMessage({
                    action: 'addPhoneNumberToSms',
                    number: celPhoneNumber
                }, '*')
            }
        }

        const registerSmsIframeLoaded = () => {
            smsIframeLoaded = true
        }

        return {
            showSmsModal,
            handleSmsClose,
            addToSms,
            registerSmsIframeLoaded
        }

    })

    if (import.meta.hot) {
        import.meta.hot.accept(acceptHMRUpdate(useSmsStore, import.meta.hot))
    }
